'use strict';

function kebabCaseToCamelCase(kebab) {
  var parts = kebab.split('-');
  var first = parts.shift();
  var capitalizedParts = parts.map(function (part) {
    return part.charAt(0).toUpperCase() + part.substring(1);
  });

  return [first].concat(capitalizedParts).join('');
}

module.exports = kebabCaseToCamelCase;



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web-drop-in/lib/kebab-case-to-camel-case.js
// module id = 382
// module chunks = 0